import { useEffect, useState } from "react";
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./Popup.module.css";
import { BookingPopupProps } from "modules/booking-popup";
import { getParentKids } from "services/get-parents-kids";
import ErrorFailed from "components/errorFailed/errorFailed";
import { KidsData } from "modules/profile";
import { getParentsKidBooking } from "services/booking/get-parents-kid-bookings";
import { BookingList } from "modules/booking";
import { getBlockData } from "services/workTime/get-block-data";
import { formatDate } from "utils/bookingPopup";
import { setBookingCancel } from "services/booking/set-booking-cancel";
import SuccessPopup from "components/successPopup/successPopup";

export default function CustomerCancelPopup({ isOpen, onClose }: BookingPopupProps) {
    const [kidsData, setKidsData] = useState<KidsData[]>([]);
    const [bookingsData, setBookingsData] = useState<BookingList[]>([]);
    const [selectedKid, setSelectedKid] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [selectedBookings, setSelectedBookings] = useState<{ id: number; recurrence?: string, date: Date, isprimey: boolean }[]>([]);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const fetchData = async () => {
        try {
            console.log('im hier')
            const kidsDataRes = await getParentKids();
            setKidsData(kidsDataRes.kids);

            if (kidsDataRes.kids && kidsDataRes.kids.length > 0) {
                const kidIds = kidsDataRes.kids.map((kid: KidsData) => kid.id);
                if (kidIds.length > 0 && selectedKid) {
                    const today = new Date();
                    const kidsBookingsData = await getParentsKidBooking(kidIds, today, ['confirmed'], true, true);
                    if (kidsBookingsData.Kids_bookings_data) {
                        const formattedBookingsData = await Promise.all(
                            kidsBookingsData.Kids_bookings_data.map(async (booking: any) => {
                                const block = await getBlockData(booking.work_time_slot_id);

                                const baseBooking = {
                                    ...booking,
                                    date: new Date(booking.date),
                                    block: `${booking.start_time.substring(0, 5) || ''} - ${booking.end_time.substring(0, 5) || ''}`,
                                    isPrimery: true,
                                };

                                const recurrences = ['recurrence_date_0', 'recurrence_date_1', 'recurrence_date_2', 'recurrence_date_3']
                                    .map((key, index) => {
                                        const statusKey = `${key}_status`;
                                        return booking[key] && booking[statusKey] === 'confirmed'
                                            ? {
                                                ...baseBooking,
                                                date: new Date(booking[key]),
                                                isPrimery: false,
                                            }
                                            : null;
                                    })
                                    .filter((recurrence) => recurrence !== null && recurrence.date > today);

                                if (booking.recurrence === "serial") {
                                    return recurrences;
                                } else {
                                    return [baseBooking];
                                }
                            })
                        );

                        const allBookings = formattedBookingsData.flat();
                        const KidBookings = allBookings.filter((booking) => {
                            const bookingDateTime = new Date(booking.date);
                            const [h, m] = booking.start_time.substring(0, 5).split(":").map(Number);
                            bookingDateTime.setHours(h, m, 0, 0);
                            return (
                                booking.kid_id.toString() === selectedKid &&
                                bookingDateTime.getTime() - Date.now() >= 24 * 60 * 60 * 1000
                            );
                        });
                        console.log(KidBookings)
                        setBookingsData(KidBookings);
                    }
                }
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
            setError("Fehler beim Laden der Daten. Bitte versuchen Sie es später erneut.");
        }
    };


    const handleCheckboxChange = (booking: BookingList, isChecked: boolean) => {
        if (isChecked) {
            if (booking.isPrimery) {
                setSelectedBookings((prev) => {
                    const relatedBookings = bookingsData
                        .filter(b => b.id === booking.id)
                        .map(b => ({
                            ...b,
                            isprimey: b.isPrimery ?? false,
                        }));
                    const newBookings = relatedBookings.filter(b => !prev.some(p => p.date.getTime() === b.date.getTime() && p.id === b.id));
                    return [...prev, ...newBookings];
                });
            } else {
                setSelectedBookings((prev) => [
                    ...prev,
                    {
                        id: booking.id,
                        recurrence: booking.recurrence,
                        date: booking.date,
                        isprimey: booking.isPrimery ?? false,
                    },
                ]);
            }
        } else {
            setSelectedBookings((prev) =>
                prev.filter((b) => !(b.date.getTime() === booking.date.getTime() && b.id === booking.id))
            );
        }
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true)
        try {
            const response = await setBookingCancel(selectedBookings);
            if (!response.success) {
                setError(response.message || 'Es ist ein Fehler bei der Buchung aufgetreten. Bitte versuchen Sie es erneut.');
                setIsLoading(false)

            } else {
                setIsSuccessPopupOpen(true);
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            console.error("Error booking request:", error);
            setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
        }
    };

    useEffect(() => {
        if (isOpen) {
            console.log('sdsdsdsd')
            fetchData();
        }
    }, [selectedKid, isOpen]);

    const handleClose = () => {
        setSelectedKid('');
        setSelectedBookings([]);
        setBookingsData([]);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Popup
            title={"Stornierung Anfrage"}
            submitLabel={""}
            closeLabel={""}
            isWithButton={false}
            isOpen={true}
            onClose={handleClose}
        >
            <form>
                {error && <ErrorFailed error={error} />}
                <div className={styles.form}>
                    <div className={commonStyles.formGroupRow}>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="kid">wählen Sie ein kind aus</label>
                            <select
                                className={commonStyles.Select}
                                value={selectedKid}
                                onChange={(e) => setSelectedKid(e.target.value)}
                            >
                                <option value="" disabled>
                                    auswählen ...
                                </option>
                                {kidsData.map((kid) => (
                                    <option key={kid.id} value={kid.id}>
                                        {kid.first_name} {kid.last_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {bookingsData.length != 0 ? (
                        <div className={commonStyles.formGroup}>
                            <div className={styles.cancelOptionsContainer}>
                                <p>Zukünftige Buchungen:</p>
                                {bookingsData.map((booking, index) => (
                                    <div className={styles.cancelOptionsRow} key={`${booking.id}-${booking.date}`}>
                                        <div className={styles.cancelOptionsRowLabels}>
                                            <label>
                                                {`Datum: ${formatDate(booking.date)}`}
                                            </label>
                                            <label>
                                                {`Block: ${booking.block}`}
                                                {booking.isPrimery
                                                    ? (booking.recurrence === "serial" ? ' Wöchentlich' : ' Einmal')
                                                    : (booking.recurrence === "serial" ? ' Untertermin' : ' Einmal')}
                                            </label>
                                        </div>
                                        <input
                                            checked={selectedBookings.some(b => b.date.getTime() === booking.date.getTime() && b.id === booking.id)}
                                            disabled={selectedBookings.some(b => !booking.isPrimery && b.id === booking.id && b.isprimey)}
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(booking, e.target.checked)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        selectedKid ? <p>Keine zukünftigen Buchungen verfügbar.</p> : <></>
                    )}
                </div>

                <div className={styles.popupButtonContainer}>
                    <button
                        type="button"
                        className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                        onClick={handleClose}
                    >
                        Schließen
                    </button>
                    <button
                        disabled={isLoading}
                        type="button"
                        className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                        onClick={handleSubmit}
                    >
                        {isLoading ? (
                            <div className={commonStyles.spinner}></div>
                        ) : (
                            "Bestätigen"
                        )}

                    </button>
                </div>
                <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                    handleClose();
                    setIsSuccessPopupOpen(false);
                }} />

            </form>
        </Popup>
    );
}
